<template>
    <div class="card">
        <div class="card-header">
            <h2 class="card-title fw-bolder">{{ sprintf($t('pages.module.eTep.exam.questionRelation.sections.title'), [exam.title ?? '']) }}</h2>
            <div class="card-toolbar">
                <div class="d-flex flex-column flex-md-row align-items-center justify-content-center gap-3">
                    <button class="btn btn-flex btn-primary" v-on:click="updateSectionBatch" type="button">
                        <span class="svg-icon svg-icon-2">
                            <inline-svg src="/media/icons/duotune/files/fil008.svg"/>
                        </span>
                        {{ $t('btn.save') }}
                    </button>
                </div>
            </div>
        </div>
        <div class="card-body">
            <div v-if="exam.sections?.length">
                <div v-for="(section, sectionIndex) in exam.sections" :key="sectionIndex" :class="[(sectionIndex > 0 ? 'mt-md-10' : 'mt-md-0'), sectionIndex !== 0 && 'mt-10' ]">
                    <div class="mb-2 d-flex justify-content-between align-items-center">
                        <div class="text-gray-800 fs-4 fw-bolder">
                            {{ sprintf($t('pages.module.eTep.exam.questionRelation.sections.titlePattern'), [(sectionIndex + 1)]) }} ( {{ treeSections.find(item => item.id === section.section_type_id)?.name }} )
                        </div>
                        <div>
                            <!-- <a class="btn btn-bg-light btn-active-color-primary btn-sm me-2" v-on:click="updateSection(section, sectionIndex)">
                                <span class="svg-icon svg-icon-3">
                                    <inline-svg src="/media/icons/duotune/files/fil008.svg"/>
                                </span>
                                <span>{{ $t('btn.save') }}</span>
                            </a> -->
                            <button class="btn btn-bg-light btn-active-color-primary btn-sm me-2" type="button" @click="showModalUpdateSection(section)"><i class="bi bi-pen"/> {{ $t('pages.module.eTep.exam.questionRelation.actions.updateItem') }}</button>
                            <el-popconfirm :title="$t('messages.sureDelete')" :confirm-button-text="$t('btn.yes')" :cancel-button-text="$t('btn.no')" @confirm="removeSection(section, sectionIndex)">
                                <template #reference>
                                    <button class="btn btn-danger btn-sm" type="button"><i class="bi bi-trash"/> {{ $t('pages.module.eTep.exam.questionRelation.actions.deleteItem') }}</button>
                                </template>
                            </el-popconfirm>
                        </div>
                    </div>
                    <div class="border border-gray-300 py-5 px-3 rounded">
                        <div class="d-flex align-items-center justify-content-between gap-3">
                            <button class="btn btn-flex btn-primary btn-sm width-max-content" v-on:click="addPart(section, sectionIndex)" type="button">
                                    <span class="svg-icon svg-icon-2">
                                        <inline-svg src="/media/icons/duotune/arrows/arr075.svg"/>
                                    </span>
                                {{ $t('pages.module.eTep.exam.questionRelation.actions.addPart') }}
                            </button>
                            <div class="d-flex align-items-center justify-content-end gap-3">
                                <label class="required fs-6 fw-bold mb-2">{{ $t('pages.module.eTep.exam.questionRelation.sections.cols.sort') }}</label>
                                <el-input-number v-model="section.sort" :min="1" size="small"/>
                            </div>
                        </div>
                        <div v-if="section.parts.length" class="mt-15">
                            <div v-for="(part, partIndex) in section.parts" :key="partIndex" :class="[(partIndex > 0 ? 'mt-md-10' : 'mt-md-0'), partIndex !== 0 && 'mt-10' ]">
                                <div class="mb-2 d-flex justify-content-between align-items-center">
                                    <div class="d-flex align-items-center gap-3">
                                        <button class="btn btn-bg-light btn-active-color-primary btn-sm me-2" @click="selectSectionAndPart(section.id, part.id, section.section_type_id)">
                                            <span class="svg-icon svg-icon-3">
                                                <inline-svg src="/media/icons/duotune/general/gen041.svg"/>
                                            </span>
                                            <span class="svg-icon svg-icon-3">
                                                {{ $t('pages.module.eTep.exam.questionRelation.parts.addQuestion') }}
                                            </span>
                                        </button>
                                        <div class="text-gray-800 fs-4 fw-bolder">
                                            {{ sprintf($t('pages.module.eTep.exam.questionRelation.parts.titlePattern'), [(partIndex + 1)]) }}
                                        </div>
                                    </div>

                                    <div class="d-flex align-items-center gap-2">
                                        <el-input-number v-model="part.sort" :min="1" size="small"/>
                                        <!-- <a class="btn btn-bg-light btn-active-color-primary btn-sm me-2" v-on:click="updatePart(part, partIndex)">
                                            <span class="svg-icon svg-icon-3">
                                                <inline-svg src="/media/icons/duotune/files/fil008.svg"/>
                                            </span>
                                            <span>
                                                {{ $t('btn.save') }}
                                            </span>
                                        </a> -->
                                        <el-popconfirm :title="$t('messages.sureDelete')" :confirm-button-text="$t('btn.yes')" :cancel-button-text="$t('btn.no')" @confirm="removePart(part, partIndex)">
                                            <template #reference>
                                                <button class="btn btn-danger btn-sm" type="button"><i class="bi bi-trash"/> {{ $t('pages.module.eTep.exam.questionRelation.actions.deleteItem') }}</button>
                                            </template>
                                        </el-popconfirm>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <p class="text-gray-600 text-center">{{ $t('pages.module.eTep.exam.questionRelation.parts.noneContent') }}</p>
            </div>
        </div>
        <div class="card-footer">
            <div class="d-flex align-items-center justify-content-between gap-3">
                <div class="d-flex align-items-center justify-content-start gap-3 w-100" v-if="treeSections.filter(item => !exam.sections?.some(section => section.section_type_id === item.id) ) && treeSections.filter(item => !exam.sections?.some(section => section.section_type_id === item.id) ).length > 0">
                    <el-select v-model="addSectionTypeId" class="w-100">
                        <el-option v-for="type in treeSections.filter(item => !exam.sections?.some(section => section.section_type_id === item.id) )" :key="type.id" :value="type.id" :label="type.name"></el-option>
                    </el-select>
                    <button class="btn btn-flex btn-primary width-max-content" v-on:click="addSection" type="button">
                        <span class="svg-icon svg-icon-2">
                            <inline-svg src="/media/icons/duotune/arrows/arr075.svg"/>
                        </span>
                        {{ $t('pages.module.eTep.exam.questionRelation.actions.addSection') }}
                    </button>
                </div>
                <div class="d-flex flex-column flex-md-row align-items-center justify-content-center gap-3">
                    <button class="btn btn-flex btn-primary" v-on:click="updateSectionBatch" type="button">
                        <span class="svg-icon svg-icon-2">
                            <inline-svg src="/media/icons/duotune/files/fil008.svg"/>
                        </span>
                        {{ $t('btn.save') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="kt_modal_update_section" ref="updateSectionModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered mw-650px">
            <div class="modal-content">
                <div class="modal-header" id="kt_modal_update_section_header">
                    <h2 class="fw-bolder">{{ form.title }}</h2>
                    <div id="kt_modal_update_section_close" data-bs-dismiss="modal" class="btn btn-icon btn-sm btn-active-icon-primary">
                        <span class="svg-icon svg-icon-1">
                            <inline-svg src="/media/icons/duotune/arrows/arr061.svg"/>
                        </span>
                    </div>
                </div>
                <el-form @submit.prevent="onSubmit" :model="form" ref="alertForm">
                    <div class="d-flex flex-column p-4" v-if="form.data.options.alert_area && form.data.options.alert_area.length">
                        <div class="fv-row" v-for="(item, index) in form.data.options.alert_area" :key="index" :class="[(index > 0), 'mt-10']">
                            <div v-if="item.type === 'alert'" class="border border-gray-300 pt-5 pb-0 px-3 rounded">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="d-flex align-items-center justify-content-between mb-4">
                                            <label class="fs-6 fw-bold">{{ $t('pages.module.eTep.question.save.alertArea.label.' + item.type) }}</label>
                                            <button class="btn btn-danger btn-sm" type="button" @click="removeAlertArea(index)"><i class="bi bi-trash"/> {{ $t('pages.module.eTep.exam.questionRelation.actions.deleteItem') }}</button>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <el-form-item :prop="'data.options.alert_area[' + index + '].content'" :rules="$validation.getMessage(['required'])">
                                            <label class="required fs-6 fw-bold">{{ $t('pages.module.eTep.question.save.alertArea.label.text') }}</label>
                                            <el-input v-model="item.content"/>
                                        </el-form-item>
                                    </div>
                                    <div class="col-md-6">
                                        <el-form-item>
                                            <el-select v-model="item.color" class="w-100">
                                                <el-option value="success" :label="$t('pages.module.eTep.question.save.alertArea.color.green')"></el-option>
                                                <el-option value="info" :label="$t('pages.module.eTep.question.save.alertArea.color.blue')"></el-option>
                                                <el-option value="warning" :label="$t('pages.module.eTep.question.save.alertArea.color.orange')"></el-option>
                                                <el-option value="danger" :label="$t('pages.module.eTep.question.save.alertArea.color.red')"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                    <div class="col-md-6">
                                        <el-form-item>
                                            <el-select v-model="item.icon" class="w-100">
                                                <el-option value="info" :label="$t('pages.module.eTep.question.save.alertArea.icons.info')"><i class="fa fa-info-circle"></i> {{ $t('pages.module.eTep.question.save.alertArea.icons.info') }}</el-option>
                                                <el-option value="calendar" :label="$t('pages.module.eTep.question.save.alertArea.icons.calendar')"><i class="fa fa-calendar-alt"></i> {{ $t('pages.module.eTep.question.save.alertArea.icons.calendar') }}</el-option>
                                                <el-option value="triangle" :label="$t('pages.module.eTep.question.save.alertArea.icons.triangle')"><i class="fa fa-exclamation-triangle"></i> {{ $t('pages.module.eTep.question.save.alertArea.icons.triangle') }}</el-option>
                                                <el-option value="tick" :label="$t('pages.module.eTep.question.save.alertArea.icons.tick')"><i class="fa fa-check-square"></i> {{ $t('pages.module.eTep.question.save.alertArea.icons.tick') }}</el-option>
                                                <el-option value="danger" :label="$t('pages.module.eTep.question.save.alertArea.icons.danger')"><i class="fa fa-exclamation-circle"></i> {{ $t('pages.module.eTep.question.save.alertArea.icons.danger') }}</el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="border border-gray-300 pt-5 px-3 pb-0 rounded">
                                <div class="d-flex align-items-center justify-content-between mb-4">
                                    <label class="required fs-6 fw-bold">{{ $t('pages.module.eTep.question.save.alertArea.label.' + item.type) }}</label>
                                    <button class="btn btn-danger btn-sm" type="button" @click="removeAlertArea(index)"><i class="bi bi-trash"/> {{ $t('pages.module.eTep.exam.questionRelation.actions.deleteItem') }}</button>
                                </div>
                                <el-form-item :prop="'data.options.alert_area[' + index + '].content'" :rules="$validation.getMessage(['required'])">
                                    <CustomCkeditor :model="item.content" @updateModel="item.content = $event"></CustomCkeditor>
                                </el-form-item>
                            </div>
                        </div>
                    </div>
                    <div class="py-10" v-else>
                        <p class="text-gray-600 text-center">{{ $t('pages.module.eTep.question.save.alertArea.addAlertContent') }}</p>
                        <div class="d-flex flex-column flex-md-row align-items-center justify-content-center gap-3">
                            <button class="btn btn-flex btn-primary" v-on:click="addAlertArea('alert')" type="button">
                                <span class="svg-icon svg-icon-2">
                                    <inline-svg src="/media/icons/duotune/arrows/arr075.svg"/>
                                </span>
                                {{ $t('pages.module.eTep.question.save.alertArea.alertAdd') }}
                            </button>
                            <button class="btn btn-flex btn-primary" v-on:click="addAlertArea('text')" type="button">
                                <span class="svg-icon svg-icon-2">
                                    <inline-svg src="/media/icons/duotune/arrows/arr075.svg"/>
                                </span>
                                {{ $t('pages.module.eTep.question.save.alertArea.contentAdd') }}
                            </button>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-between" id="kt_modal_update_section_footer" ref="modalUpdateSectionFooter">
                        <div class="d-flex flex-column flex-md-row align-items-center justify-content-start gap-3" v-if="form.data.options.alert_area && form.data.options.alert_area.length">
                            <button class="btn btn-flex btn-primary" v-on:click="addAlertArea('alert')" type="button">
                                <span class="svg-icon svg-icon-2">
                                    <inline-svg src="/media/icons/duotune/arrows/arr075.svg"/>
                                </span>
                                {{ $t('pages.module.eTep.question.save.alertArea.alertAdd') }}
                            </button>
                            <button class="btn btn-flex btn-primary" v-on:click="addAlertArea('text')" type="button">
                                <span class="svg-icon svg-icon-2">
                                    <inline-svg src="/media/icons/duotune/arrows/arr075.svg"/>
                                </span>
                                {{ $t('pages.module.eTep.question.save.alertArea.contentAdd') }}
                            </button>
                        </div>
                        <button class="btn btn-flex btn-primary" type="submit">
                            {{ $t('btn.save') }}
                        </button>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import CustomTable from "@/components/custom-table";
import ElSelectTree from "@/components/ElSelectTree.vue";
import Button from "@/components/module/popup/Button.vue";
import CustomCkeditor from "@/components/custom-ckeditor/index.vue";

export default {
    name: "index",
    props: ['examID'],
    components: {
        CustomCkeditor,
        Button,
        ElSelectTree,
        CustomTable
    },
    data() {
        return {
            form: {
                updateStatus: false,
                loading: false,
                data: {
                    options: {
                        alert_area: []
                    }
                }
            },
            examQuestion: {
                fields: [
                    {
                        name: this.$t("common.id"),
                        key: "id",
                        class: ""
                    },
                    {
                        name: this.$t("common.sort"),
                        scopedSlots: {customRender: "sort"}
                    },
                    {
                        name: this.$t("pages.module.eTep.question.cols.title"),
                        scopedSlots: {customRender: "title"}
                    },
                    {
                        name: this.$t("pages.module.eTep.question.cols.type"),
                        scopedSlots: {customRender: "type"}
                    },
                    {
                        name: this.$t("common.action"),
                        key: "action",
                        scopedSlots: {customRender: "actions"}
                    }
                ],
                list: {},
                pagination: {
                    current: 1,
                    pageSize: 10,
                    total: 0
                }
            },
            question: {
                fields: [
                    {
                        name: this.$t("common.id"),
                        key: "id",
                        class: ""
                    },
                    {
                        name: this.$t("pages.module.eTep.question.cols.title"),
                        scopedSlots: {customRender: "title"}
                    },
                    {
                        name: this.$t("pages.module.eTep.question.cols.type"),
                        scopedSlots: {customRender: "type"}
                    },
                    {
                        name: this.$t("common.action"),
                        key: "action",
                        scopedSlots: {customRender: "actions"}
                    }
                ],
            },
            questionFilterData: {},
            exam: {
                translate: {},
                questions: [],
            },
            questionTreeCategories: [],
            examQuestionRelationResponseMessages: {
                you_have_reached_max_question_adding_limit: "youHaveReachedMaxQuestionAddLimit",
            },
            firstLoad: false,
            showDetailData: null,
            cloneQuestion: {
                types: ['overwrite', 'flush'],
                form: {
                    title: '',
                    loading: false,
                    data: {}
                },
                responseMessages: {
                    questions_cannot_changed_while_exam_has_starter_or_is_about_to_begin: "questionCannotChangedWhileStartExam",
                },
            },
            gainModel: [],
            addSectionTypeId: '',
            treeSections: [],
            selectedSectionID: null,
            selectedPartID: null,
        }
    },
    computed: {
        questionTable() {
            let table = this.cloneData(this.$store.state.module.etep.question.table);

            table.data = table.data.map((question) => {
                let found = this.exam.questions.filter((examQuestion) => examQuestion.id === question.id);

                if (found.length === 1) {
                    question.pivot = found[0].pivot;
                }

                return question;
            })

            return table;
        },
        questionTypes() {
            return this.$store.state.module.etep.question.type.table.data;
        },
        selectedSection() {
            return this.exam.sections?.find(item => item.id === this.selectedSectionID);
        },
    },
    created() {
        if (!this.examID || !(this.examID > 0)) {
            this.$router.push({
                path: "/module/etep/exam"
            });
        }
    },
    mounted() {
        if (this.examID && this.examID > 0) {
            this.loadExam();
            this.loadQuestionTreeCategories();
            this.loadTreeSections();

            this.$store.dispatch('module/exam/question/type/get', {
                page: {pageSize: 9999}
            });

            this.$store.dispatch('module/exam/get', {
                page: {pageSize: 9999}
            });
        }
    },
    beforeUnmount() {
        this.eventBus.$off('cloneQuestion', undefined, true);
    },
    methods: {
        loadExam() {
            this.axios.get(this.endpoints['module_etep_exam'] + '/' + this.examID).then((response) => {
                let data = response.data.data;
                data.translate = this.resolveDatum(data.translations, this.$root.defaultLanguage.id, 'language_id');

                this.exam = data;

                let examQuestions = {};
                data.questions.forEach((question) => {
                    examQuestions[question.id] = question;
                });

                this.examQuestion.list = examQuestions;
                this.examQuestion.pagination.total = data.questions.length;

                if (!this.firstLoad) {
                    this.questionFilterData.type_id = data.question_type_id;
                    this.questionFilterData.include_answers = 1;
                    this.onQuestionFilter();
                    this.firstLoad = true;
                }
            })
        },
        loadQuestionTreeCategories() {
            this.axios.get(this.endpoints['module_etep_question_category'] + '/tree').then((response) => {
                this.questionTreeCategories = response.data.data;
            });
        },
        loadTreeSections() {
            this.axios.get(this.endpoints['module_etep_section_type']).then((response) => {
                this.treeSections = response.data.data;
            });
        },
        onQuestionFilter() {
            this.$store.dispatch('module/etep/question/get', {
                page: {},
                filterData: this.questionFilterData
            });
        },
        getCorrectAnswer(record) {
            let result = null;

            if (record.answers && record.answers.length && record.correct_answer_id) {
                record.answers.sort((a, b) => {
                    return a.sort - b.sort;
                });

                let foundIndex = record.answers.findIndex((answer) => answer.id === record.correct_answer_id);

                if (foundIndex !== -1) {
                    result = {
                        foundIndex: foundIndex,
                        record: record.answers[foundIndex],
                    }
                }
            }

            return result;
        },
        getRecord(type, record) {
            if (this.questionTypes.length) {
                let recordTypeCode = this.resolveDatum(this.questionTypes, record.question_type_id, 'id').code;
                let splitted = recordTypeCode.split('_').map((part) => this.ucFirst(part));

                let methodName = 'getRecord' + splitted.join('');

                return this[methodName] ? this[methodName](type, record) : false
            }
        },
        addSection() {
            let sectionLength = this.exam.sections.length;
            let formData = {
                "exam_id": this.examID,
                "section_type_id": this.addSectionTypeId,
                "options": null,
                "sort": this.exam.sections.length !== 0 ? (this.exam.sections[sectionLength - 1].sort + 1) : 1,
            }
            this.axios.post(this.endpoints['module_etep_exam_section'], formData).then(response => {
                this.onResponse(response.data, () => {
                    this.loadExam();
                }, () => {
                    this.form.loading = false;
                });
            }).catch(error => {
                this.onResponseFailure(error.response.data, () => {
                    this.form.loading = false;
                }, false);
            });
        },
        updateSection(section, sectionIndex) {
            let formData = {
                "options": section.options,
                "sort": section.sort,
            }
            this.axios.put(this.endpoints['module_etep_exam_section'] + '/' + section.id, formData).then(response => {
                this.onResponse(response.data, () => {
                    this.loadExam();
                }, () => {
                    this.form.loading = false;
                });
            }).catch(error => {
                this.onResponseFailure(error.response.data, () => {
                    this.form.loading = false;
                }, false);
            });
        },
        removeSection(section, sectionIndex) {
            this.$store.dispatch("module/etep/exam/section/delete", {
                id: [section.id]
            }).then((successDeleted) => {
                if (successDeleted) {
                    this.loadExam();
                    this.form.loading = false;
                }
            });
        },
        addPart(section, sectionIndex) {
            let partsLength = this.exam.sections[sectionIndex].parts.length;
            let formData = {
                "section_id": section.id,
                "options": null,
                "sort": partsLength ? this.exam.sections[sectionIndex].parts[partsLength - 1].sort + 1 : 1,
            }
            this.axios.post(this.endpoints['module_etep_exam_part'], formData).then(response => {
                this.onResponse(response.data, () => {
                    this.loadExam();
                }, () => {
                    this.form.loading = false;
                });
            }).catch(error => {
                this.onResponseFailure(error.response.data, () => {
                    this.form.loading = false;
                }, false);
            });
        },
        updatePart(part, partIndex) {
            let formData = {
                "options": part.options,
                "sort": part.sort,
            }
            this.axios.put(this.endpoints['module_etep_exam_part'] + '/' + part.id, formData).then(response => {
                this.onResponse(response.data, () => {
                    this.loadExam();
                }, () => {
                    this.form.loading = false;
                });
            }).catch(error => {
                this.onResponseFailure(error.response.data, () => {
                    this.form.loading = false;
                }, false);
            });
        },
        removePart(part, partIndex) {
            this.$store.dispatch("module/etep/exam/part/delete", {
                id: [part.id]
            }).then((successDeleted) => {
                if (successDeleted) {
                    this.loadExam();
                    this.form.loading = false;
                }
            });
        },
        selectSectionAndPart(sectionID, partID, sectionTypeID) {
            this.$emit('setTabName', 'questionRelationSettings');
            this.eventBus.$emit('selectPartInSectionForQuestion', {
                sectionID: sectionID,
                partID: partID,
                sectionTypeID: sectionTypeID,
            });
        },
        updateSectionBatch() {
            const formData = {
                "items": this.exam.sections.map(item => ({
                    "id": item.id,
                    "options": item.options,
                    "sort": item.sort
                }))
            }

            const allParts = {
                "items": this.exam.sections.flatMap(section => section.parts).map(item => ({
                    "id": item.id,
                    "options": item.options,
                    "sort": item.sort
                }))
            }

            this.axios.put(this.endpoints['module_etep_exam_section'] + '/batch', formData).then(response => {
                this.onResponse(response.data, () => {

                    this.axios.put(this.endpoints['module_etep_exam_part'] + '/batch', allParts).then(response => {
                        this.onResponse(response.data, () => {
                            this.loadExam();
                        });
                    }).catch(error => {
                        this.onResponseFailure(error.response.data);
                    });
                }, false, false);
            }).catch(error => {
                this.onResponseFailure(error.response.data);
            });
        },
        showModalUpdateSection(record) {
            this.form.updateStatus = true;
            this.form.title = this.$t("pages.module.eTep.question.save.alertArea.sectionTitle");
            this.axios.get(this.endpoints['module_etep_exam_section'] + '/' + record.id).then(response => {
                this.form.data = response.data.data;
                this.form.data.options = this.form.data.options || {};
                this.form.data.options.alert_area = response.data.data?.options?.alert_area ?? [];
                this.showModal(this.$refs.updateSectionModal);
            });
        },
        addAlertArea(type) {
            this.form.data?.options?.alert_area.push({
                "type": type,
                "icon": "info",
                "color": "success",
                "content": "",
            })
        },
        removeAlertArea(index) {
            this.form.data.options.alert_area.splice(index, 1);
        },
        onSubmit() {
            this.$refs.alertForm.validate(async (valid) => {
                if (valid) {
                    this.form.loading = true;

                    if (this.form.data.id) {
                        await this.axios.put(this.endpoints['module_etep_exam_section'] + '/' + this.form.data.id, this.form.data).then(response => {
                            this.onResponse(response.data, () => {
                                this.hideModal(this.$refs.updateSectionModal);
                            }, () => {
                                this.form.loading = false;
                            });
                        }).catch(error => {
                            if (error) {
                                this.onResponseFailure(error.response.data, () => {
                                    this.form.loading = false;
                                });
                            }
                        });
                    }
                } else {
                    return false;
                }
            });
        }
    }
}
</script>

<style>
.table p {
    margin-bottom: 0;
}

.table img, .modal .detail-item img {
    width: 150px !important;
    height: 75px !important;
    object-fit: cover !important;
}

.width-max-content {
    min-width: max-content;
}
</style>